import api from './api';

export const GET_CHANNELS = () => {
	return api.get('api/v2/channels').json();
};
